import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d5ac7a8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tir-pm-tooltip-element__content" }

import { computed, PropType, ref } from "vue";
import { TirPmTooltipElementPlacementEnum } from "./enums";
import {
  PopoverColorEnum,
  PopoverPositionEnum,
  TirPmPopover,
} from "tir-pm-popover";


export default /*#__PURE__*/_defineComponent({
  __name: 'tir-pm-tooltip-element',
  props: {
  /**Позиция */
  position: {
    type: String as PropType<TirPmTooltipElementPlacementEnum>,
    default: TirPmTooltipElementPlacementEnum.Top,
  },
  /**Скрывать треугольник */
  isHideTriangle: {
    type: Boolean,
    default: false,
  },
  /**Классы компонента */
  classes: { type: String },
  /**Ширина */
  width: { type: String, default: "10.313rem" },
  /**Задержку при открытии тултипа */
  openDelay: { type: Number, default: 150 },
  /**Задержка при закрытии тултипа */
  closeDelay: { type: Number, default: 50 },
  /**Неактивность */
  isDisabled: { type: Boolean, default: false },
  /**Неактивность телепорта */
  isNoTeleport: { type: Boolean, default: false },
},
  setup(__props, { expose: __expose }) {

const props = __props;



/**Ссылка на компоненте popover */
const $popover = ref<InstanceType<typeof TirPmPopover>>();

/**Позиция поповера */
const popoverPosition = computed(() => {
  switch (props.position) {
    case TirPmTooltipElementPlacementEnum.Top:
      return PopoverPositionEnum.Top;
    case TirPmTooltipElementPlacementEnum.Right:
      return PopoverPositionEnum.Right;
    case TirPmTooltipElementPlacementEnum.Bottom:
      return PopoverPositionEnum.Bottom;
    case TirPmTooltipElementPlacementEnum.Left:
      return PopoverPositionEnum.Left;
  }
});
/**Классы поповера */
const popoverClasses = computed(() =>
  props.classes
    ? `${props.classes} tir-pm-tooltip-element__popover`
    : "tir-pm-tooltip-element__popover"
);

/**Экспорт методов управления видимости компонента popover */
__expose({
  open: () => $popover.value?.open(),
  close: () => $popover.value?.close(),
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TirPmPopover), {
    ref_key: "$popover",
    ref: $popover,
    "is-tooltip": true,
    position: popoverPosition.value,
    color: _unref(PopoverColorEnum).Black,
    "is-hide-triangle": __props.isHideTriangle,
    classes: popoverClasses.value,
    width: __props.width,
    "is-disabled": __props.isDisabled,
    "is-no-teleport": __props.isNoTeleport,
    "tooltip-open-delay": __props.openDelay,
    "tooltip-close-delay": __props.closeDelay
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "content")
      ])
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["position", "color", "is-hide-triangle", "classes", "width", "is-disabled", "is-no-teleport", "tooltip-open-delay", "tooltip-close-delay"]))
}
}

})